export default __webpack_public_path__ + "static/media/fire-sprinkler-icon.6a7117ba.svg";